import React from 'react'
import { object } from 'prop-types'
import FeaturedPost from './Components/FeaturedPosts/Post'
import Section from './Components/Section/Section'
import CommentsSection from './Components/CommentsSection/CommentsSection'

function Show({ post = null }) {
  const {
    id,
    title,
    slug,
    image,
    newImage,
    content,
    categories,
    comments,
    relatedPosts,
    publish_date: publishDate,
  } = post || {}

  return (
    <div className="blog-page">
      <div className="blog-page-landing">
        <div className="container-fixed">
          <div className="row justify-content-center">
            <div className="col-12 col-xl-10">
              <FeaturedPost
                titleComponent="h1"
                titleStyle="h2"
                categories={categories}
                publishDate={publishDate}
                image={image}
                newImage={newImage}
                title={title}
                slug={slug}
                wrapped
                withBreadcrumbs
                isPostPage
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fixed">
        <div className="row justify-content-center new-blog-page-container">
          <div className="col-12 col-lg-10 col-xl-8">
            <div
              className="new-blog-page-content__html"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        </div>

        {!!relatedPosts?.length && (
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10 col-xl-8">
              <Section
                title="Related posts"
                posts={relatedPosts}
                centered
                responsive
                isRelatedPost
              />
            </div>
          </div>
        )}

        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">
            <CommentsSection itemId={id} initialComments={comments} />
          </div>
        </div>
      </div>
    </div>
  )
}

Show.propTypes = {
  post: object,
}

export default Show
